// deps
import styled from "styled-components";

export const Container = styled.div(({ theme }) => {
    return {
        display: "flex",
        alignItems: "center",
        padding: `${theme.spacing.xxSmall}`,
        margin: `${theme.spacing.empty} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}`,
        borderRadius: `${theme.cornerRadius.small}`,
        height: "46px",
        background: `${theme.colors[theme.colorMode].background_Primary}`,
        boxShadow: `0px ${theme.spacing.xSmall} ${theme.spacing.medium} 0px rgba(27,30,36,0.10)`,
        border: "1px solid transparent",
    };
});
